import { render, staticRenderFns } from "./packet.vue?vue&type=template&id=227f973f&scoped=true&"
import script from "./packet.vue?vue&type=script&lang=ts&"
export * from "./packet.vue?vue&type=script&lang=ts&"
import style0 from "./packet.vue?vue&type=style&index=0&id=227f973f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227f973f",
  null
  
)

export default component.exports